import { Button, Stack, Step, StepLabel, Stepper } from "@mui/material";
import { Form } from "formik";
import React, { useState } from "react";
import { Oval } from "react-loading-icons";

export default function RenderSwitch({
  children,
  loading,
  errors,
  handleInputChange,
  registerCustomer,
  terms,
}) {
  const stepsArray = React.Children.toArray(children);
  const [step, setStep] = useState(0);
  const currentStep = stepsArray[step];

  console.log(loading)

  return (
    <Form className="my-5" onChange={handleInputChange}
    autoComplete="off"
    >
      <Stepper alternativeLabel activeStep={step} className="mb-10">
        {stepsArray.map((step, i) => (
          <Step key={i} completed={step > i}>
            <StepLabel sx={{ color: "#ff2000" }}>{step.props.label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {currentStep}
      <Stack direction="row" spacing={2} sx={{ marginTop: 5 }}>
        {step !== 0 ? (
          <Button
            variant="outlined"
            onClick={() => {
              step > 0 ? setStep(step - 1) : setStep(0);
            }}
          >
            {step > 0 || step === stepsArray.length - 1 ? "Back" : null}
          </Button>
        ) : null}

        {step !== stepsArray.length - 1 ? (
          <Button
            variant="outlined"
            onClick={() => {
              step < stepsArray.length - 1
                ? setStep(step + 1)
                : setStep(stepsArray.length - 1);
            }}
          >
            Next
          </Button>
        ) : (
          <>
            <button
              type="button"
              onClick={registerCustomer}
              className={`w-full py-3 px-5 bg-red-650 rounded-lg text-white bg-[#26220a] flex justify-center mt-5 ${
                terms  ? null : "hidden"
              }`}
            >
              {loading ? (
                <div className="flex justify-center w-full items-center">
                  <Oval />
                </div>
              ) : (
                <p>Create Account</p>
              )}
            </button>
          </>
        )}
      </Stack>
    </Form>
  );
}
